// NOTE: This file is a duplicate of Ready/apps/workkeys/src/modules/reporting/constants/workkeysReplaceTerms.ts
// When qti-pwa is merged into the Ready monorepo, this file can be removed and replaced with the one in WorkKeys.
export const WORKKEYS_REPLACE_TERMS: Record<string, string> = {
  school: "institution",
  schools: "institutions",
  "school district": "institution",
  "school districts": "institutions",
  "school admin": "institution admin",
  "school admins": "institution admins",

  teacher: "instructor",
  teachers: "instructors",

  student: "learner",
  students: "learners",

  masteryprep: "ACT WorkKeys Curriculum", // MasteryPrep: "ACT WorkKeys Curriculum"

  test: "quiz",
  practice_test: "quiz",
  "practice test": "quiz", // For display labels
  diagnostic_test: "Diagnostic",
  mastery_lesson: "lesson",

  "current school year": "Current Institution Year",
  "last school year": "Last Institution Year"
}

export const WORKKEYS_REPLACE_FILTER_KEYS: Record<string, string> = {
  school: "institution",
  teacher: "instructor",
  student: "learner"
}

export const WORKKEYS_REPLACE_SEARCH_PARAMS: Record<string, string> = {
  institution: "school",
  instructor: "teacher",
  learner: "student"
}

export const WORKKEYS_REPLACE_URL_SUBPAGE: Record<string, string> = {
  schools: "institutions",
  teachers: "instructors",
  students: "learners",
  "students-usage": "learners-usage"
}

export const WORKKEYS_REPLACE_URL_CONTENT_TYPE: Record<string, string> = {
  "practice-test": "quiz",
  "mastery-lesson": "online-lesson"
}

export const WORKKEYS_REPLACE_URL_CONTENT_TYPE_REVERSE: Record<string, string> = {
  quiz: "practice-test",
  "online-lesson": "mastery-lesson"
}

export const WORKKEYS_REPLACE_QUERY_CONTENT_TYPE: Record<string, string> = {
  practice_test: "quiz",
  mastery_lesson: "online_lesson"
}

// Reverse mapping for reading from URL
export const WORKKEYS_REPLACE_QUERY_CONTENT_TYPE_REVERSE: Record<string, string> = {
  quiz: "practice_test",
  online_lesson: "mastery_lesson"
}
